import { useCallback, useEffect, useState } from 'react';
import { normalizeScope } from '../utils/scopeSelection';

/*
 * Расчёт по кнопке для ScopeFilter.
 *
 * Галочки меняют черновик, а применённый scope (тот, по которому идут
 * запросы) меняется только в `apply`. Раньше каждый клик сразу перезапускал
 * аналитику: при выборе локации, пока пользователь ещё отмечал камеры, уже
 * считались все её камеры, и экран подвисал.
 *
 * Если применённый scope поменялся снаружи (Back/Forward, «Все доступные»,
 * восстановление из кэша), черновик выравнивается по нему.
 */
const scopeKey = (scope) => JSON.stringify(normalizeScope(scope));

export const useDraftScope = (applied, commit) => {
  const appliedKey = scopeKey(applied);
  const [draft, setDraft] = useState(() => normalizeScope(applied));

  useEffect(() => { setDraft(JSON.parse(appliedKey)); }, [appliedKey]);

  const dirty = scopeKey(draft) !== appliedKey;
  const apply = useCallback(() => commit(normalizeScope(draft)), [commit, draft]);

  return { draft, setDraft, dirty, apply };
};

export default useDraftScope;
